import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#B08D3F]">
    {children}
  </p>
);

export const PageHero = ({ eyebrow, headline, subhead, children }) => (
  <section className="border-b border-[#E4E7EC] bg-[#F5F6F8]">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mt-4 max-w-3xl font-serif2 text-4xl font-semibold leading-tight tracking-tight text-[#1F2D4E] sm:text-5xl"
      >
        {headline}
      </motion.h1>
      {subhead && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
          className="mt-6 max-w-2xl text-lg leading-relaxed text-[#5A6B8C]"
        >
          {subhead}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
